// Privana-authored Safety presentation; tenant content is never a catalogue entry.
export default {
  "copy": {
    "accident": "Accidente",
    "nearMiss": "Incidente sin daños",
    "propertyDamage": "Daños materiales",
    "memberComplaint": "Queja de socio",
    "safeguardingConcern": "Preocupación sobre la protección de personas vulnerables",
    "securityIncident": "Incidente de seguridad",
    "vehicleIncident": "Incidente con vehículo",
    "environmentalIncident": "Incidente medioambiental",
    "other": "Otro",
    "low": "Baja",
    "medium": "Media",
    "high": "Alta",
    "critical": "Crítica",
    "open": "Abierto",
    "investigating": "En investigación",
    "awaitingAction": "Pendiente de actuación",
    "closed": "Cerrado",
    "member": "Socio",
    "staff": "Personal",
    "contractor": "Contratista",
    "visitor": "Visitante",
    "guest": "Invitado",
    "inProgress": "En curso",
    "completed": "Completado",
    "cancelled": "Cancelado",
    "photo": "Foto",
    "document": "Documento",
    "witnessStatement": "Declaración de testigo",
    "medical": "Médico",
    "clear": "Borrar",
    "searching": "Buscando...",
    "noMatchesFound": "No se encontraron coincidencias.",
    "occurredTimeIn12HourFormat": "Hora del incidente en formato de 12 horas",
    "affectedPerson": "Persona afectada",
    "remove": "Eliminar",
    "personType": "Tipo de persona",
    "affectedMember": "Socio afectado",
    "searchMemberNameEmailOrNumber": "Buscar por nombre, correo o número de socio",
    "affectedStaffMember": "Empleado afectado",
    "searchStaffNameOrEmail": "Buscar por nombre o correo del empleado",
    "name": "Nombre",
    "nameIfKnown": "Nombre, si se conoce",
    "roleInIncident": "Papel en el incidente",
    "affectedPersonBystanderDriver": "Persona afectada, testigo presencial, conductor...",
    "treatmentGiven": "Atención prestada",
    "firstAidNoneAmbulance": "Primeros auxilios, ninguna, ambulancia...",
    "injuryNotes": "Notas sobre lesiones",
    "injuryDetailsOrAffectedPersonNotes": "Detalles de las lesiones o notas sobre la persona afectada",
    "additionalNotes": "Notas adicionales",
    "sentToHospital": "Trasladado al hospital",
    "addAShortTitleForTheIncident": "Añade un título breve para el incidente.",
    "addWhenTheIncidentHappened": "Indica cuándo ocurrió el incidente.",
    "unableToSaveIncident": "No se pudo guardar el incidente.",
    "basicDetails": "Datos básicos",
    "incidentType": "Tipo de incidente",
    "severity": "Gravedad",
    "status": "Estado",
    "title": "Título",
    "eGSlipNearPoolSteps": "p. ej., resbalón cerca de las escaleras de la piscina",
    "occurredDateTime": "Fecha y hora del incidente",
    "location": "Ubicación",
    "poolDeckKitchenCarPark": "Zona de piscina, cocina, aparcamiento...",
    "areaDepartment": "Área/departamento",
    "leisureFBGrounds": "Ocio, alimentos y bebidas, mantenimiento de exteriores...",
    "description": "Descripción",
    "affectedPersonS": "Personas afectadas",
    "addAffectedPerson": "Añadir persona afectada",
    "immediateAction": "Actuación inmediata",
    "firstAidAreaMadeSafeManagerNotified": "Primeros auxilios, zona asegurada, responsable avisado...",
    "investigation": "Investigación",
    "investigationNotes": "Notas de investigación",
    "rootCause": "Causa raíz",
    "correctiveActionSummary": "Resumen de medidas correctivas",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "saveIncident": "Guardar incidente",
    "addWitness": "Añadir testigo",
    "searchMember": "Buscar socio",
    "searchStaff": "Buscar empleado",
    "injuryDescriptionNotes": "Descripción de lesiones / notas",
    "witnessType": "Tipo de testigo",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "statement": "Declaración",
    "actionTitle": "Título de la acción",
    "searchAssignee": "Buscar responsable",
    "actionDescription": "Descripción de la acción",
    "save": "Guardar",
    "chooseAFileToUpload": "Selecciona un archivo para subir.",
    "unableToUploadAttachment": "No se pudo subir el archivo adjunto.",
    "uploadAttachment": "Subir archivo adjunto",
    "uploading": "Subiendo...",
    "upload": "Subir",
    "unableToLoadIncident": "No se pudo cargar el incidente.",
    "unableToOpenAttachment": "No se pudo abrir el archivo adjunto.",
    "unableToCloseIncident": "No se pudo cerrar el incidente.",
    "loadingIncident": "Cargando incidente...",
    "backToIncidentLog": "Volver al registro de incidentes",
    "edit": "Editar",
    "closeIncident": "Cerrar incidente",
    "noDescriptionAddedYet": "Aún no se ha añadido una descripción.",
    "locationLabel": "Ubicación:",
    "area": "Área:",
    "affectedPersonLabel": "Persona afectada:",
    "add": "Añadir",
    "noNotesAdded": "No se han añadido notas.",
    "noAffectedPeopleAddedYet": "Aún no se han añadido personas afectadas.",
    "witnesses": "Testigos",
    "noStatementAddedYet": "Aún no se ha añadido una declaración.",
    "noWitnessesAddedYet": "Aún no se han añadido testigos.",
    "followUpActions": "Acciones de seguimiento",
    "noDescription": "Sin descripción.",
    "due": "Vencimiento:",
    "noDate": "Sin fecha",
    "markComplete": "Marcar como completado",
    "noFollowUpActionsYet": "Aún no hay acciones de seguimiento.",
    "attachments": "Archivos adjuntos",
    "previewView": "Vista previa/Ver",
    "download": "Descargar",
    "linkedAttachment": "Archivo adjunto enlazado",
    "noAttachmentsUploadedYet": "Aún no se han subido archivos adjuntos.",
    "immediateActionLabel": "Actuación inmediata:",
    "investigationNotesLabel": "Notas de investigación:",
    "rootCauseLabel": "Causa raíz:",
    "correctiveAction": "Medidas correctivas:",
    "auditHistory": "Historial de auditoría",
    "readOnlyAuditEntry": "Entrada de auditoría de solo lectura",
    "noAuditEntriesYet": "Aún no hay entradas de auditoría.",
    "closureNotesCorrectiveActionSummary": "Notas de cierre / resumen de medidas correctivas",
    "optionalNotesOrCorrectiveActionSummary": "Notas opcionales o resumen de medidas correctivas",
    "closing": "Cerrando...",
    "unableToLoadIncidents": "No se pudieron cargar los incidentes.",
    "editIncident": "Editar incidente",
    "newIncident": "Nuevo incidente",
    "openIncidents": "Incidentes abiertos",
    "closedThisMonth": "Cerrados este mes",
    "incidentLog": "Registro de incidentes",
    "newIncidentLabel": "Nuevo incidente",
    "searchIncidents": "Buscar incidentes...",
    "allStatuses": "Todos los estados",
    "allTypes": "Todos los tipos",
    "allSeverities": "Todos los niveles de gravedad",
    "loadingIncidents": "Cargando incidentes...",
    "incidentNumber": "Número de incidente",
    "date": "Fecha",
    "type": "Tipo",
    "actions": "Acciones",
    "view": "Ver",
    "noIncidentsFound": "No se encontraron incidentes",
    "select": "Seleccionar...",
    "search": "Buscar...",
    "firstAid": "Primeros auxilios",
    "fireMarshal": "Responsable de evacuación y prevención de incendios",
    "foodHygiene": "Higiene alimentaria",
    "safeguarding": "Protección de personas vulnerables",
    "poolPlant": "Instalaciones técnicas de piscina",
    "healthSafety": "Salud y seguridad",
    "manualHandling": "Manipulación manual de cargas",
    "groundsMaintenance": "Mantenimiento de exteriores",
    "pesticideApplication": "Aplicación de plaguicidas",
    "machinery": "Maquinaria",
    "insurance": "Seguro",
    "methodStatement": "Procedimiento de trabajo",
    "riskAssessment": "Evaluación de riesgos",
    "custom": "Personalizado",
    "active": "Activo",
    "expiringSoon": "Próximo a vencer",
    "expired": "Vencido",
    "missingExpiry": "Sin fecha de vencimiento",
    "archived": "Archivado",
    "certificate": "Certificado",
    "addACertificationOrDocumentName": "Añade el nombre de la certificación o del documento.",
    "uploadsMustBe25MBOrSmaller": "Los archivos deben tener un tamaño máximo de 25 MB.",
    "chooseAStaffMember": "Selecciona un empleado.",
    "chooseOrCreateAContractor": "Selecciona o crea un contratista.",
    "addAHolderName": "Añade el nombre del titular.",
    "unableToSaveCertification": "No se pudo guardar la certificación.",
    "editCertification": "Editar certificación",
    "addCertification": "Añadir certificación",
    "holder": "Titular",
    "holderType": "Tipo de titular",
    "staffMember": "Empleado",
    "searchStaffLabel": "Buscar empleado...",
    "searchContractors": "Buscar contratistas...",
    "createContractor": "Crear contratista",
    "companyNameIfNotListed": "Nombre de la empresa si no aparece en la lista",
    "holderName": "Nombre del titular",
    "nameOrOrganisation": "Nombre u organización",
    "certificationDetails": "Datos de la certificación",
    "certificationName": "Nombre de la certificación",
    "eGEmergencyFirstAidAtWork": "p. ej., primeros auxilios de emergencia en el trabajo",
    "issuingBody": "Entidad emisora",
    "trainingProviderOrAuthority": "Proveedor de formación o autoridad",
    "certificateNumber": "Número de certificado",
    "issueDate": "Fecha de expedición",
    "expiryDate": "Fecha de vencimiento",
    "notes": "Notas",
    "documents": "Documentos",
    "viewDownload": "Ver / Descargar",
    "attachmentType": "Tipo de archivo adjunto",
    "certificateUpload": "Subir certificado",
    "saveChanges": "Guardar cambios",
    "certification": "Certificación",
    "issuingBodyLabel": "Entidad emisora",
    "expiryDateLabel": "Fecha de vencimiento",
    "attachment": "Archivo adjunto",
    "noFile": "Sin archivo",
    "archive": "Archivar",
    "unableToLoadCertifications": "No se pudieron cargar las certificaciones.",
    "unableToArchiveCertification": "No se pudo archivar la certificación.",
    "totalCertifications": "Total de certificaciones",
    "expiringIn30Days": "Vencen en 30 días",
    "missingExpiryLabel": "Sin fecha de vencimiento",
    "contractorDocuments": "Documentos de contratistas",
    "certificationRegister": "Registro de certificaciones",
    "addCertificationLabel": "Añadir certificación",
    "staffCertifications": "Certificaciones del personal",
    "contractorDocumentsLabel": "Documentos de contratistas",
    "documentLibrary": "Biblioteca de documentos",
    "searchHolderCertificationIssuingBody": "Buscar titular, certificación, entidad emisora...",
    "allHolders": "Todos los titulares",
    "loadingCertifications": "Cargando certificaciones...",
    "fileName": "Nombre del archivo",
    "uploadDate": "Fecha de subida",
    "previewDownload": "Vista previa / Descargar",
    "noDocumentsUploadedYet": "Aún no se han subido documentos.",
    "noCertificationsAddedYet": "Aún no se han añadido certificaciones",
    "archiveCertification": "Archivar certificación",
    "archiving": "Archivando...",
    "fireSafety": "Prevención de incendios",
    "kitchen": "Cocina",
    "clubhouse": "Casa club",
    "golfCourse": "Campo de golf",
    "pool": "Piscina",
    "gym": "Gimnasio",
    "maintenance": "Mantenimiento",
    "housekeeping": "Limpieza",
    "security": "Seguridad",
    "general": "General",
    "adHoc": "Puntual",
    "daily": "Diaria",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "quarterly": "Trimestral",
    "annually": "Anual",
    "text": "Texto",
    "number": "Número",
    "signature": "Firma",
    "policy": "Política",
    "procedure": "Procedimiento",
    "emergencyPlan": "Plan de emergencia",
    "firePlan": "Plan contra incendios",
    "templates": "Plantillas",
    "checklistRuns": "Ejecuciones de listas",
    "riskAssessments": "Evaluaciones de riesgos",
    "complianceCalendar": "Calendario de cumplimiento",
    "fireSafetyCheck": "Revisión de prevención de incendios",
    "firstAidKitCheck": "Revisión del botiquín",
    "kitchenOpeningCheck": "Revisión de apertura de cocina",
    "poolSafetyCheck": "Revisión de seguridad de piscina",
    "golfCourseMachineryCheck": "Revisión de maquinaria del campo de golf",
    "clubhouseWalkthrough": "Inspección de la casa club",
    "pass": "Conforme",
    "failed": "No conforme",
    "mixed": "Mixto",
    "incomplete": "Incompleto",
    "inProgressLabel": "En curso",
    "overdue": "Vencido",
    "moreActions": "Más acciones",
    "selectedTeamMember": "Empleado seleccionado",
    "searchByNameOrEmail": "Buscar por nombre o correo electrónico",
    "noMatchingTeamMembers": "No se encontraron empleados coincidentes.",
    "scheduledChecklist": "Lista programada",
    "dueLabel": "Vencimiento",
    "runNow": "Ejecutar ahora",
    "openRun": "Abrir ejecución",
    "nothingHere": "No hay elementos.",
    "viewMore": "Ver más",
    "close": "Cerrar",
    "unableToSaveTemplate": "No se pudo guardar la plantilla.",
    "editChecklistTemplate": "Editar plantilla de lista",
    "createChecklistTemplate": "Crear plantilla de lista",
    "templateName": "Nombre de la plantilla",
    "category": "Categoría",
    "areaDepartmentLabel": "Área / departamento",
    "frequency": "Frecuencia",
    "defaultDueTime": "Hora de vencimiento predeterminada",
    "hH": "HH",
    "mM": "MM",
    "activeTemplate": "Plantilla activa",
    "recurringSchedule": "Programación recurrente",
    "startDate": "Fecha de inicio",
    "endDateOptional": "Fecha de fin opcional",
    "createRunXDaysBeforeDue": "Crear ejecución X días antes del vencimiento",
    "defaultAssignees": "Responsables predeterminados",
    "nextDuePreview": "Vista previa del próximo vencimiento:",
    "savedAfterTemplateIsCreatedOrUpdated": "Se guardará al crear o actualizar la plantilla.",
    "automaticSchedulingIsOff": "La programación automática está desactivada.",
    "checklistItems": "Elementos de la lista",
    "addItem": "Añadir elemento",
    "itemLabel": "Etiqueta del elemento",
    "helpText": "Texto de ayuda",
    "response": "Respuesta",
    "required": "Obligatorio",
    "optional": "Opcional",
    "photoOnFail": "Foto si no es conforme",
    "noPhotoRule": "Sin requisito de foto",
    "saveTemplate": "Guardar plantilla",
    "unableToStartRun": "No se pudo iniciar la ejecución.",
    "runChecklist": "Ejecutar lista",
    "template": "Plantilla",
    "selectTemplate": "Seleccionar plantilla",
    "assignTo": "Asignar a",
    "dueDateTime": "Fecha / hora de vencimiento",
    "starting": "Iniciando...",
    "startRun": "Iniciar ejecución",
    "noEvidenceUploadedYet": "Aún no se han subido evidencias.",
    "checklistRun": "Ejecución de lista",
    "loadingChecklistRun": "Cargando ejecución de lista...",
    "assignedTo": "Asignado a:",
    "unassigned": "Sin asignar",
    "fail": "No conforme",
    "pending": "Pendiente",
    "yes": "Sí",
    "no": "No",
    "evidence": "Evidencias",
    "completeRun": "Completar ejecución",
    "editRiskAssessment": "Editar evaluación de riesgos",
    "addRiskAssessment": "Añadir evaluación de riesgos",
    "areaLabel": "Área",
    "owner": "Responsable",
    "hazard": "Peligro",
    "whoMayBeHarmed": "Quién puede sufrir daños",
    "controls": "Medidas de control",
    "likelihood15": "Probabilidad (1-5)",
    "severity15": "Gravedad (1-5)",
    "riskScore": "Puntuación de riesgo",
    "reviewDate": "Fecha de revisión",
    "furtherActionRequired": "Medidas adicionales necesarias",
    "noDescriptionLabel": "Sin descripción",
    "complete": "Completar",
    "noActionsAddedYet": "Aún no se han añadido acciones.",
    "dueDate": "Fecha de vencimiento",
    "addAction": "Añadir acción",
    "uploadEvidence": "Subir evidencias",
    "saveRiskAssessment": "Guardar evaluación de riesgos",
    "uploadDocument": "Subir documento",
    "version": "Versión",
    "file": "Archivo",
    "unableToLoadSafetyChecklists": "No se pudieron cargar las listas de seguridad.",
    "dueThisWeek": "Vencen esta semana",
    "dueThisMonth": "Vencen este mes",
    "later": "Más adelante",
    "archiveChecklistTemplate": "Archivar plantilla de lista",
    "archiveRiskAssessment": "Archivar evaluación de riesgos",
    "archiveSafetyDocument": "Archivar documento de seguridad",
    "unableToArchiveThisRecord": "No se pudo archivar este registro.",
    "activeTemplates": "Plantillas activas",
    "completedThisMonth": "Completadas este mes",
    "overdueChecks": "Revisiones vencidas",
    "openRiskActions": "Acciones de riesgo abiertas",
    "docsDueReview": "Documentos pendientes de revisión",
    "safetyChecklists": "Listas de seguridad",
    "createTemplate": "Crear plantilla",
    "loadingOperationalSafetySystem": "Cargando sistema de seguridad operativa...",
    "searchTemplates": "Buscar plantillas...",
    "allCategories": "Todas las categorías",
    "allFrequencies": "Todas las frecuencias",
    "activeOnly": "Solo activas",
    "allTemplates": "Todas las plantillas",
    "archivedOnly": "Solo archivadas",
    "schedule": "Programación",
    "nextDue": "Próximo vencimiento",
    "items": "Elementos",
    "manual": "Manual",
    "inactive": "Inactivo",
    "runChecklistLabel": "Ejecutar lista",
    "noChecklistTemplatesYet": "Aún no hay plantillas de listas",
    "searchRuns": "Buscar ejecuciones...",
    "allResults": "Todos los resultados",
    "runNumber": "Número de ejecución",
    "assignedToLabel": "Asignado a",
    "result": "Resultado",
    "activeRisks": "Riesgos activos",
    "highRisk": "Riesgo alto",
    "reviewDue": "Revisión pendiente",
    "openActions": "Acciones abiertas",
    "searchRisks": "Buscar riesgos...",
    "allScores": "Todas las puntuaciones",
    "highRiskOnly": "Solo riesgo alto",
    "riskNumber": "Número de riesgo",
    "searchDocuments": "Buscar documentos...",
    "documentType": "Tipo de documento",
    "preview": "Vista previa",
    "noSafetyDocumentsUploadedYet": "Aún no se han subido documentos de seguridad.",
    "archiveRecord": "Archivar registro",
    "everythingLooksHealthy": "Todo está en buen estado.",
    "aFewItemsNeedAttention": "Algunos elementos necesitan atención.",
    "severalComplianceAreasNeedReview": "Varias áreas de cumplimiento necesitan revisión.",
    "immediateSafetyAttentionRequired": "Se requiere atención inmediata a la seguridad.",
    "unableToLoadSafetyDashboard": "No se pudo cargar el panel de seguridad.",
    "dashboardCouldNotLoad": "No se pudo cargar el panel",
    "retry": "Reintentar",
    "safetyComplianceOverview": "Resumen del cumplimiento de seguridad",
    "criticalItems": "Elementos críticos",
    "needsAttention": "Necesita atención",
    "refreshed": "Actualizado",
    "overallComplianceScore": "Puntuación global de cumplimiento",
    "overdueChecklists": "Listas vencidas",
    "certsExpiring": "Certificaciones próximas a vencer",
    "riskReviewsDue": "Revisiones de riesgos pendientes",
    "policiesAndProcedures": "Políticas y procedimientos",
    "attentionRequired": "Atención necesaria",
    "noUrgentSafetyActions": "No hay acciones de seguridad urgentes",
    "recentActivity": "Actividad reciente",
    "noRecentSafetyActivityYet": "Aún no hay actividad de seguridad reciente.",
    "incidentBreakdown": "Desglose de incidentes",
    "noIncidentsRecorded": "No hay incidentes registrados.",
    "checklistHealth": "Estado de las listas",
    "passRate": "Porcentaje de conformidad",
    "certificationHealth": "Estado de las certificaciones",
    "valid": "Vigente",
    "expiring": "Próximo a vencer",
    "riskDocumentHealth": "Estado de riesgos y documentos",
    "highRisks": "Riesgos altos",
    "loadingDashboard": "Cargando panel...",
    "loadingIncidentLog": "Cargando registro de incidentes...",
    "loadingCertificationsLabel": "Cargando certificaciones...",
    "loadingChecklists": "Cargando listas...",
    "passFail": "Conforme / No conforme",
    "yesNo": "Sí / No",
    "criticalHighIncidents": "Incidentes críticos/graves",
    "addFollowUpAction": "Añadir acción de seguimiento",
    "noExpiryRecorded": "Sin vencimiento registrado",
    "expiresToday": "Vence hoy",
    "healthy": "Buen estado",
    "atRisk": "En riesgo",
    "noDateSet": "Sin fecha definida",
    "affectedPersonNumber": "Persona afectada {number}",
    "existingAffectedPersonNumber": "Persona afectada {number} (existente)",
    "removeAssignee": "Eliminar a {name}",
    "assignee": "responsable",
    "openCertificationActions": "Abrir acciones de {name}",
    "showingCalendarItems": "Mostrando 3 de {count}",
    "calendarItemsOne": "{count} elemento ordenado del más reciente al más antiguo.",
    "calendarItemsOther": "{count} elementos ordenados del más reciente al más antiguo.",
    "dueOn": "Vencimiento: {date}",
    "actionDescriptionDue": "{description} · vencimiento: {date}",
    "nextDueOn": "Próximo vencimiento: {date}",
    "runDescription": "{template} · {category} · Vencimiento: {date}",
    "assignedToNames": "Asignado a: {names}",
    "assignedCount": "{count} asignados",
    "openActionCount": "{count} abiertas",
    "automaticFrequency": "{frequency} · Automática",
    "starterExamples": "Empieza con ejemplos adecuados para clubes como revisiones de prevención de incendios, del botiquín, de apertura de cocina, de seguridad de piscina, de maquinaria del campo de golf e inspecciones de la casa club.",
    "expiryOverdueOne": "{count} día de retraso",
    "expiryOverdueOther": "{count} días de retraso",
    "expiryRemainingOne": "Queda {count} día",
    "expiryRemainingOther": "Quedan {count} días",
    "highCriticalCount": "{count} graves/críticos",
    "dueInSevenDays": "{count} vencen en 7 días",
    "expiredCount": "{count} vencidas",
    "riskActionCounts": "{high} altos · {actions} acciones",
    "activity": "Actividad de seguridad",
    "certificationExpires": "{name} · Vence el {date}",
    "moreCertifications": "+{count} más",
    "moveItemUp": "Subir elemento",
    "moveItemDown": "Bajar elemento",
    "dateFrom": "Fecha desde",
    "dateTo": "Fecha hasta",
    "cancelForm": "Cancelar formulario",
    "slipTripOrFall": "Resbalón, tropiezo o caída",
    "cutOrLaceration": "Corte o laceración",
    "burn": "Quemadura",
    "allergicReaction": "Reacción alérgica",
    "foodPoisoning": "Intoxicación alimentaria",
    "equipmentRelatedInjury": "Lesión relacionada con equipos",
    "drowningNearDrowning": "Ahogamiento / conato de ahogamiento",
    "fire": "Incendio",
    "flood": "Inundación",
    "gasLeak": "Fuga de gas",
    "powerOutage": "Corte de electricidad",
    "structuralDamage": "Daño estructural",
    "chemicalSpill": "Derrame químico",
    "securityBreach": "Vulneración de seguridad",
    "theft": "Robo",
    "vandalism": "Vandalismo",
    "minorNoMedicalAttentionRequired": "Leve - No requiere atención médica",
    "moderateFirstAidAdministered": "Moderada - Se administraron primeros auxilios",
    "seriousMedicalAttentionRequired": "Grave - Requiere atención médica",
    "criticalEmergencyServicesCalled": "Crítica - Se avisó a los servicios de emergencia",
    "updateSafetyIncidentReport": "Actualizar informe de incidente de seguridad",
    "newSafetyIncidentReport": "Nuevo informe de incidente de seguridad",
    "typeOfIncident": "Tipo de incidente *",
    "severityLevel": "Nivel de gravedad *",
    "locationOfIncident": "Ubicación del incidente *",
    "eGPoolDeckMainDiningRoomTennisCourt1": "p. ej., zona de piscina, comedor principal, pista de tenis 1",
    "detailedDescription": "Descripción detallada *",
    "describeWhatHappenedHowItHappenedAndAnyContributingFactors": "Describe qué ocurrió, cómo ocurrió y los factores que contribuyeron...",
    "injuredAffectedPerson": "Persona lesionada/afectada",
    "fullNameOfInjuredPerson": "Nombre completo de la persona lesionada",
    "personTypeLegacy": "Tipo de persona",
    "clubMember": "Socio del club",
    "memberGuest": "Invitado de socio",
    "staffMemberLegacy": "Empleado *",
    "enterWitnessName": "Introduce el nombre del testigo",
    "immediateActionTaken": "Actuación inmediata realizada *",
    "describeTheImmediateResponseFirstAidGivenAreaSecuredEtc": "Describe la respuesta inmediata, los primeros auxilios prestados, cómo se aseguró la zona, etc.",
    "medicalAttentionRequired": "Requiere atención médica",
    "emergencyServicesCalled": "Se avisó a los servicios de emergencia",
    "reportedToAuthorities": "Se informó a las autoridades",
    "photosTakenOfScene": "Se tomaron fotos del lugar",
    "followUpActionRequired": "Requiere acción de seguimiento",
    "updateReport": "Actualizar informe",
    "submitIncidentReport": "Enviar informe de incidente",
    "cPRCardiopulmonaryResuscitation": "CPR (reanimación cardiopulmonar)",
    "firstAidLegacy": "Primeros auxilios",
    "aEDAutomatedExternalDefibrillator": "AED (desfibrilador externo automático)",
    "lifeguardCertification": "Certificación de socorrismo",
    "waterSafetyInstructor": "Instructor de seguridad acuática",
    "poolOperatorCertification": "Certificación de operador de piscina",
    "foodSafetyServSafe": "Seguridad alimentaria/ServSafe",
    "foodHandlerCertificate": "Certificado de manipulador de alimentos",
    "allergenAwareness": "Conocimiento sobre alérgenos",
    "fireSafetyTraining": "Formación en prevención de incendios",
    "fireExtinguisherTraining": "Formación en uso de extintores",
    "emergencyResponseTraining": "Formación en respuesta a emergencias",
    "workplaceSafetyOSHA": "Seguridad laboral (OSHA)",
    "hazardousMaterialsHandling": "Manipulación de materiales peligrosos",
    "chemicalSafetyTraining": "Formación en seguridad química",
    "electricalSafety": "Seguridad eléctrica",
    "forkliftOperation": "Manejo de carretillas elevadoras",
    "defensiveDriving": "Conducción preventiva",
    "securityTraining": "Formación en seguridad",
    "incidentCommandSystemICS": "Sistema de mando de incidentes (ICS)",
    "bloodbornePathogensTraining": "Formación sobre patógenos transmitidos por la sangre",
    "confinedSpaceEntry": "Entrada en espacios confinados",
    "fallProtection": "Protección contra caídas",
    "personalProtectiveEquipmentPPE": "Equipos de protección individual (PPE)",
    "riskAssessmentLegacy": "Evaluación de riesgos",
    "emergencyActionPlanTraining": "Formación en planes de actuación ante emergencias",
    "evacuationProcedures": "Procedimientos de evacuación",
    "childProtectionSafeguarding": "Protección de menores/personas vulnerables",
    "mentalHealthFirstAid": "Primeros auxilios en salud mental",
    "wildernessFirstAid": "Primeros auxilios en entornos naturales",
    "localFireDepartment": "Servicio local de bomberos",
    "localHealthDepartment": "Autoridad sanitaria local",
    "stateCertificationBoard": "Organismo estatal de certificación",
    "professionalAssociation": "Asociación profesional",
    "trainingCompany": "Empresa de formación",
    "updateStaffCertification": "Actualizar certificación del personal",
    "addStaffCertification": "Añadir certificación del personal",
    "enterStaffMemberName": "Introduce el nombre del empleado",
    "certificationType": "Tipo de certificación *",
    "selectCertificationType": "Seleccionar tipo de certificación",
    "issuingOrganization": "Entidad emisora *",
    "selectIssuingOrganization": "Seleccionar entidad emisora",
    "issueDateLegacy": "Fecha de expedición *",
    "expiryDateLegacy": "Fecha de vencimiento *",
    "certificateDocument": "Documento del certificado",
    "clickToUploadCertificateOrDragAndDrop": "Haz clic para subir el certificado o arrástralo aquí",
    "pDFJPGPNGUpTo10MB": "PDF, JPG, PNG de hasta 10 MB",
    "certificateUploaded": "✓ Certificado subido: {file}",
    "updateCertification": "Actualizar certificación",
    "staffMemberTitle": "Empleado",
    "highCriticalOne": "{count} grave/crítico",
    "highCriticalOther": "{count} graves/críticos",
    "dueSevenOne": "{count} vence en 7 días",
    "dueSevenOther": "{count} vencen en 7 días",
    "expiredOne": "{count} vencida",
    "expiredOther": "{count} vencidas",
    "openActionOne": "{count} abierta",
    "openActionOther": "{count} abiertas",
    "assignedOne": "{count} asignado",
    "assignedOther": "{count} asignados",
    "riskActionOneOne": "{high} alto · {actions} acción",
    "riskActionOneOther": "{high} alto · {actions} acciones",
    "riskActionOtherOne": "{high} altos · {actions} acción",
    "riskActionOtherOther": "{high} altos · {actions} acciones",
    "affectedPeopleHelp": "Añade a cada socio, empleado, invitado, visitante, contratista u otra persona afectada por el incidente.",
    "incidentDescriptionPlaceholder": "¿Qué ocurrió? Describe los hechos con claridad y de forma adecuada para el club.",
    "attachmentUploadHelp": "Se admiten imágenes, PDF, documentos de Word, archivos de texto y CSV de hasta 25 MB.",
    "closeIncidentConfirmation": "¿Cerrar este incidente? Podrás seguir consultando el registro y el historial de auditoría.",
    "incidentFormHelp": "Registra ahora los datos esenciales; podrás ampliar las notas de investigación y el seguimiento más adelante.",
    "incidentRegisterHelp": "Un registro seguro de accidentes del club para incidentes, incidentes sin daños, acciones de seguimiento e historial de auditoría.",
    "incidentEmptyHelp": "Prueba a borrar los filtros o crea el primer incidente cuando haya algo que registrar.",
    "certificationFormHelp": "Mantén las cualificaciones del personal y los documentos de cumplimiento de contratistas en un único registro seguro.",
    "renewalNotesPlaceholder": "Notas útiles para la renovación, restricciones o comprobaciones de evidencias.",
    "certificateUploadHelp": "Se admiten imágenes, PDF, documentos de Word, archivos de texto y CSV de hasta 25 MB. Los archivos se almacenan de forma privada y se abren mediante enlaces firmados.",
    "certificationRegisterHelp": "Controla los registros de primeros auxilios, responsables de incendios, higiene alimentaria, protección de personas vulnerables, DBS, seguros de contratistas, RAMS y otros registros de cumplimiento.",
    "archiveCertificationConfirmation": "¿Archivar esta certificación? Se ocultará de las vistas de cumplimiento activas, pero se conservará en el historial de auditoría.",
    "templateFormHelp": "Crea una revisión de seguridad repetible para el club con campos de respuesta prácticos y reglas de evidencias.",
    "recurringReminderHelp": "El personal asignado recibirá un correo y una notificación de Privana 24 horas antes del vencimiento de cada ejecución programada.",
    "adHocScheduleHelp": "Las plantillas puntuales solo se ejecutan manualmente. Elige una frecuencia diaria, semanal, mensual, trimestral o anual para activar la programación automática.",
    "startRunHelp": "Selecciona una plantilla, responsables y fecha de vencimiento para esta revisión.",
    "riskFormHelp": "Describe el peligro, las medidas de control y la frecuencia de revisión con claridad.",
    "documentStorageHelp": "Almacenamiento privado de documentos con enlaces firmados de vista previa y descarga.",
    "checklistRegisterHelp": "Plantillas, revisiones en curso, evaluaciones de riesgos, documentos y próximas fechas de cumplimiento de tu club.",
    "archiveRecordHelp": "Se ocultará de las vistas activas, pero se conservará en el historial de auditoría.",
    "dashboardUpToDateHelp": "Los incidentes, certificaciones, ejecuciones de listas, riesgos y documentos están al día.",
    "dbs": "DBS",
    "coshh": "COSHH",
    "rams": "RAMS",
    "cctv": "CCTV",
    "teamMember": "Miembro del equipo",
    "memberNumber": "Socio n.º {number}"
  },
  "enums": {
    "accident": "Accidente",
    "near_miss": "Incidente sin daños",
    "property_damage": "Daños materiales",
    "member_complaint": "Queja de socio",
    "safeguarding_concern": "Preocupación sobre la protección de personas vulnerables",
    "security_incident": "Incidente de seguridad",
    "vehicle_incident": "Incidente con vehículo",
    "environmental_incident": "Incidente medioambiental",
    "other": "Otro",
    "low": "Baja",
    "medium": "Media",
    "high": "Alta",
    "critical": "Crítica",
    "open": "Abierto",
    "investigating": "En investigación",
    "awaiting_action": "Pendiente de actuación",
    "closed": "Cerrado",
    "member": "Socio",
    "staff": "Personal",
    "contractor": "Contratista",
    "visitor": "Visitante",
    "guest": "Invitado",
    "in_progress": "En curso",
    "completed": "Completado",
    "cancelled": "Cancelado",
    "photo": "Foto",
    "document": "Documento",
    "witness_statement": "Declaración de testigo",
    "medical": "Médico",
    "cctv": "CCTV",
    "first_aid": "Primeros auxilios",
    "fire_marshal": "Responsable de evacuación y prevención de incendios",
    "food_hygiene": "Higiene alimentaria",
    "safeguarding": "Protección de personas vulnerables",
    "dbs": "DBS",
    "pool_plant": "Instalaciones técnicas de piscina",
    "health_safety": "Salud y seguridad",
    "coshh": "COSHH",
    "manual_handling": "Manipulación manual de cargas",
    "grounds_maintenance": "Mantenimiento de exteriores",
    "pesticide_application": "Aplicación de plaguicidas",
    "machinery": "Maquinaria",
    "insurance": "Seguro",
    "rams": "RAMS",
    "method_statement": "Procedimiento de trabajo",
    "risk_assessment": "Evaluación de riesgos",
    "custom": "Personalizado",
    "valid": "Activo",
    "expiring_soon": "Próximo a vencer",
    "expired": "Vencido",
    "missing_expiry": "Sin fecha de vencimiento",
    "archived": "Archivado",
    "certificate": "Certificado",
    "fire_safety": "Prevención de incendios",
    "kitchen": "Cocina",
    "clubhouse": "Casa club",
    "golf_course": "Campo de golf",
    "pool": "Piscina",
    "gym": "Gimnasio",
    "maintenance": "Mantenimiento",
    "housekeeping": "Limpieza",
    "security": "Seguridad",
    "general": "General",
    "ad_hoc": "Puntual",
    "daily": "Diaria",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "quarterly": "Trimestral",
    "annually": "Anual",
    "text": "Texto",
    "number": "Número",
    "signature": "Firma",
    "policy": "Política",
    "procedure": "Procedimiento",
    "emergency_plan": "Plan de emergencia",
    "fire_plan": "Plan contra incendios",
    "templates": "Plantillas",
    "runs": "Ejecuciones de listas",
    "risks": "Evaluaciones de riesgos",
    "documents": "Documentos",
    "calendar": "Calendario de cumplimiento",
    "draft": "Borrador",
    "review_due": "Revisión pendiente",
    "scheduled_checklist": "Lista programada",
    "checklist_run": "Ejecución de lista",
    "checklist": "Lista",
    "incident": "Incidente",
    "risk": "Riesgo",
    "safety_document": "Documento de seguridad",
    "evidence": "Evidencias",
    "inactive": "Inactivo",
    "blocked": "Bloqueado"
  },
  "audit": {
    "incident_created": "Incidente creado",
    "incident_updated": "Incidente actualizado",
    "incident_closed": "Incidente cerrado",
    "certification_created": "Certificación creada",
    "certification_updated": "Certificación actualizada",
    "certification_archived": "Certificación archivada",
    "person_added": "Persona añadida",
    "person_updated": "Persona actualizada",
    "person_removed": "Persona eliminada",
    "witness_added": "Testigo añadido",
    "witness_updated": "Testigo actualizado",
    "witness_removed": "Testigo eliminado",
    "action_added": "Acción añadida",
    "action_updated": "Acción actualizada",
    "action_cancelled": "Acción cancelada",
    "attachment_added": "Archivo adjunto añadido",
    "attachment_uploaded": "Archivo adjunto subido",
    "attachment_removed": "Archivo adjunto eliminado",
    "created": "Creado",
    "updated": "Actualizado",
    "archived": "Archivado",
    "cancelled": "Cancelado",
    "completed": "Completado",
    "item_added": "Elemento añadido",
    "item_updated": "Elemento actualizado",
    "item_removed": "Elemento eliminado",
    "item_completed": "Elemento completado",
    "schedule_recalculated": "Programación recalculada",
    "scheduled_run_created": "Ejecución programada creada"
  },
  "errors": {
    "unknown": "No se pudo completar esta solicitud de seguridad. Inténtalo de nuevo.",
    "server_error": "No se pudo completar esta solicitud de seguridad. Inténtalo de nuevo.",
    "validation_error": "Revisa los campos obligatorios, fechas, puntuaciones y evidencias antes de continuar.",
    "not_found": "Este registro o archivo de seguridad ya no está disponible.",
    "run_locked": "Esta ejecución es de solo lectura. Las ejecuciones completadas o canceladas no se pueden modificar.",
    "invalid_upload": "Selecciona un archivo válido para subir.",
    "file_too_large": "Los archivos adjuntos deben tener un tamaño máximo de 25 MB.",
    "unsupported_file_type": "Sube una imagen, PDF, documento de Word, archivo de texto o CSV.",
    "upload_storage_unavailable": "El almacenamiento de archivos adjuntos de seguridad no está disponible. Contacta con soporte.",
    "unauthorized": "Inicia sesión para acceder a Prevención.",
    "forbidden": "No tienes permiso para realizar esta acción de seguridad.",
    "timeout": "La solicitud de seguridad agotó el tiempo de espera. Inténtalo de nuevo.",
    "network_error": "No se pudo conectar con Prevención. Comprueba la conexión e inténtalo de nuevo.",
    "invalid_json": "No se pudo leer la respuesta de seguridad. Inténtalo de nuevo."
  },
  "generated": {
    "overdueChecklist": "Lista vencida: {name}",
    "expiredCertification": "Certificación vencida: {name}",
    "riskReviewDue": "Revisión de riesgo pendiente: {name}",
    "documentReviewDue": "Revisión de documento pendiente: {name}",
    "checklistDueSoon": "Lista próxima a vencer: {name}",
    "certificationExpiresSoon": "Certificación próxima a vencer: {name}",
    "incidentSeverity": "Incidente abierto de gravedad {severity}",
    "viewIncident": "Ver incidente",
    "reviewCertificate": "Revisar certificado",
    "reviewRisk": "Revisar riesgo",
    "reviewDocument": "Revisar documento",
    "openCalendar": "Abrir calendario",
    "openRun": "Abrir ejecución",
    "incidentUpdated": "Incidente actualizado",
    "certificationUpdated": "Certificación actualizada",
    "safetyItemUpdated": "Elemento de seguridad actualizado",
    "activity_incident_created_incident": "Incidente creado",
    "activity_incident_updated_incident": "Incidente actualizado",
    "activity_incident_closed_incident": "Incidente cerrado",
    "activity_certification_created_incident": "Certificación creada",
    "activity_certification_updated_incident": "Certificación actualizada",
    "activity_certification_archived_incident": "Certificación archivada",
    "activity_person_added_incident": "Persona añadida · incidente",
    "activity_person_updated_incident": "Persona actualizada · incidente",
    "activity_person_removed_incident": "Persona eliminada · incidente",
    "activity_witness_added_incident": "Testigo añadido · incidente",
    "activity_witness_updated_incident": "Testigo actualizado · incidente",
    "activity_witness_removed_incident": "Testigo eliminado · incidente",
    "activity_action_added_incident": "Acción añadida · incidente",
    "activity_action_updated_incident": "Acción actualizada · incidente",
    "activity_action_cancelled_incident": "Acción cancelada · incidente",
    "activity_attachment_added_incident": "Archivo adjunto añadido · incidente",
    "activity_attachment_uploaded_incident": "Archivo adjunto subido · incidente",
    "activity_attachment_removed_incident": "Archivo adjunto eliminado · incidente",
    "activity_created_incident": "Creado · incidente",
    "activity_updated_incident": "Actualizado · incidente",
    "activity_archived_incident": "Archivado · incidente",
    "activity_cancelled_incident": "Cancelado · incidente",
    "activity_completed_incident": "Completado · incidente",
    "activity_item_added_incident": "Elemento añadido · incidente",
    "activity_item_updated_incident": "Elemento actualizado · incidente",
    "activity_item_removed_incident": "Elemento eliminado · incidente",
    "activity_item_completed_incident": "Elemento completado · incidente",
    "activity_schedule_recalculated_incident": "Programación recalculada · incidente",
    "activity_scheduled_run_created_incident": "Ejecución programada creada",
    "activity_incident_created_certification": "Incidente creado",
    "activity_incident_updated_certification": "Incidente actualizado",
    "activity_incident_closed_certification": "Incidente cerrado",
    "activity_certification_created_certification": "Certificación creada",
    "activity_certification_updated_certification": "Certificación actualizada",
    "activity_certification_archived_certification": "Certificación archivada",
    "activity_person_added_certification": "Persona añadida · certificación",
    "activity_person_updated_certification": "Persona actualizada · certificación",
    "activity_person_removed_certification": "Persona eliminada · certificación",
    "activity_witness_added_certification": "Testigo añadido · certificación",
    "activity_witness_updated_certification": "Testigo actualizado · certificación",
    "activity_witness_removed_certification": "Testigo eliminado · certificación",
    "activity_action_added_certification": "Acción añadida · certificación",
    "activity_action_updated_certification": "Acción actualizada · certificación",
    "activity_action_cancelled_certification": "Acción cancelada · certificación",
    "activity_attachment_added_certification": "Archivo adjunto añadido · certificación",
    "activity_attachment_uploaded_certification": "Archivo adjunto subido · certificación",
    "activity_attachment_removed_certification": "Archivo adjunto eliminado · certificación",
    "activity_created_certification": "Creado · certificación",
    "activity_updated_certification": "Actualizado · certificación",
    "activity_archived_certification": "Archivado · certificación",
    "activity_cancelled_certification": "Cancelado · certificación",
    "activity_completed_certification": "Completado · certificación",
    "activity_item_added_certification": "Elemento añadido · certificación",
    "activity_item_updated_certification": "Elemento actualizado · certificación",
    "activity_item_removed_certification": "Elemento eliminado · certificación",
    "activity_item_completed_certification": "Elemento completado · certificación",
    "activity_schedule_recalculated_certification": "Programación recalculada · certificación",
    "activity_scheduled_run_created_certification": "Ejecución programada creada",
    "activity_incident_created_checklist_run": "Incidente creado",
    "activity_incident_updated_checklist_run": "Incidente actualizado",
    "activity_incident_closed_checklist_run": "Incidente cerrado",
    "activity_certification_created_checklist_run": "Certificación creada",
    "activity_certification_updated_checklist_run": "Certificación actualizada",
    "activity_certification_archived_checklist_run": "Certificación archivada",
    "activity_person_added_checklist_run": "Persona añadida · ejecución de lista",
    "activity_person_updated_checklist_run": "Persona actualizada · ejecución de lista",
    "activity_person_removed_checklist_run": "Persona eliminada · ejecución de lista",
    "activity_witness_added_checklist_run": "Testigo añadido · ejecución de lista",
    "activity_witness_updated_checklist_run": "Testigo actualizado · ejecución de lista",
    "activity_witness_removed_checklist_run": "Testigo eliminado · ejecución de lista",
    "activity_action_added_checklist_run": "Acción añadida · ejecución de lista",
    "activity_action_updated_checklist_run": "Acción actualizada · ejecución de lista",
    "activity_action_cancelled_checklist_run": "Acción cancelada · ejecución de lista",
    "activity_attachment_added_checklist_run": "Archivo adjunto añadido · ejecución de lista",
    "activity_attachment_uploaded_checklist_run": "Archivo adjunto subido · ejecución de lista",
    "activity_attachment_removed_checklist_run": "Archivo adjunto eliminado · ejecución de lista",
    "activity_created_checklist_run": "Creado · ejecución de lista",
    "activity_updated_checklist_run": "Actualizado · ejecución de lista",
    "activity_archived_checklist_run": "Archivado · ejecución de lista",
    "activity_cancelled_checklist_run": "Cancelado · ejecución de lista",
    "activity_completed_checklist_run": "Completado · ejecución de lista",
    "activity_item_added_checklist_run": "Elemento añadido · ejecución de lista",
    "activity_item_updated_checklist_run": "Elemento actualizado · ejecución de lista",
    "activity_item_removed_checklist_run": "Elemento eliminado · ejecución de lista",
    "activity_item_completed_checklist_run": "Elemento completado · ejecución de lista",
    "activity_schedule_recalculated_checklist_run": "Programación recalculada · ejecución de lista",
    "activity_scheduled_run_created_checklist_run": "Ejecución programada creada",
    "activity_incident_created_checklist_template": "Incidente creado",
    "activity_incident_updated_checklist_template": "Incidente actualizado",
    "activity_incident_closed_checklist_template": "Incidente cerrado",
    "activity_certification_created_checklist_template": "Certificación creada",
    "activity_certification_updated_checklist_template": "Certificación actualizada",
    "activity_certification_archived_checklist_template": "Certificación archivada",
    "activity_person_added_checklist_template": "Persona añadida · plantilla de lista",
    "activity_person_updated_checklist_template": "Persona actualizada · plantilla de lista",
    "activity_person_removed_checklist_template": "Persona eliminada · plantilla de lista",
    "activity_witness_added_checklist_template": "Testigo añadido · plantilla de lista",
    "activity_witness_updated_checklist_template": "Testigo actualizado · plantilla de lista",
    "activity_witness_removed_checklist_template": "Testigo eliminado · plantilla de lista",
    "activity_action_added_checklist_template": "Acción añadida · plantilla de lista",
    "activity_action_updated_checklist_template": "Acción actualizada · plantilla de lista",
    "activity_action_cancelled_checklist_template": "Acción cancelada · plantilla de lista",
    "activity_attachment_added_checklist_template": "Archivo adjunto añadido · plantilla de lista",
    "activity_attachment_uploaded_checklist_template": "Archivo adjunto subido · plantilla de lista",
    "activity_attachment_removed_checklist_template": "Archivo adjunto eliminado · plantilla de lista",
    "activity_created_checklist_template": "Creado · plantilla de lista",
    "activity_updated_checklist_template": "Actualizado · plantilla de lista",
    "activity_archived_checklist_template": "Archivado · plantilla de lista",
    "activity_cancelled_checklist_template": "Cancelado · plantilla de lista",
    "activity_completed_checklist_template": "Completado · plantilla de lista",
    "activity_item_added_checklist_template": "Elemento añadido · plantilla de lista",
    "activity_item_updated_checklist_template": "Elemento actualizado · plantilla de lista",
    "activity_item_removed_checklist_template": "Elemento eliminado · plantilla de lista",
    "activity_item_completed_checklist_template": "Elemento completado · plantilla de lista",
    "activity_schedule_recalculated_checklist_template": "Programación recalculada · plantilla de lista",
    "activity_scheduled_run_created_checklist_template": "Ejecución programada creada",
    "activity_incident_created_risk_assessment": "Incidente creado",
    "activity_incident_updated_risk_assessment": "Incidente actualizado",
    "activity_incident_closed_risk_assessment": "Incidente cerrado",
    "activity_certification_created_risk_assessment": "Certificación creada",
    "activity_certification_updated_risk_assessment": "Certificación actualizada",
    "activity_certification_archived_risk_assessment": "Certificación archivada",
    "activity_person_added_risk_assessment": "Persona añadida · evaluación de riesgos",
    "activity_person_updated_risk_assessment": "Persona actualizada · evaluación de riesgos",
    "activity_person_removed_risk_assessment": "Persona eliminada · evaluación de riesgos",
    "activity_witness_added_risk_assessment": "Testigo añadido · evaluación de riesgos",
    "activity_witness_updated_risk_assessment": "Testigo actualizado · evaluación de riesgos",
    "activity_witness_removed_risk_assessment": "Testigo eliminado · evaluación de riesgos",
    "activity_action_added_risk_assessment": "Acción añadida · evaluación de riesgos",
    "activity_action_updated_risk_assessment": "Acción actualizada · evaluación de riesgos",
    "activity_action_cancelled_risk_assessment": "Acción cancelada · evaluación de riesgos",
    "activity_attachment_added_risk_assessment": "Archivo adjunto añadido · evaluación de riesgos",
    "activity_attachment_uploaded_risk_assessment": "Archivo adjunto subido · evaluación de riesgos",
    "activity_attachment_removed_risk_assessment": "Archivo adjunto eliminado · evaluación de riesgos",
    "activity_created_risk_assessment": "Creado · evaluación de riesgos",
    "activity_updated_risk_assessment": "Actualizado · evaluación de riesgos",
    "activity_archived_risk_assessment": "Archivado · evaluación de riesgos",
    "activity_cancelled_risk_assessment": "Cancelado · evaluación de riesgos",
    "activity_completed_risk_assessment": "Completado · evaluación de riesgos",
    "activity_item_added_risk_assessment": "Elemento añadido · evaluación de riesgos",
    "activity_item_updated_risk_assessment": "Elemento actualizado · evaluación de riesgos",
    "activity_item_removed_risk_assessment": "Elemento eliminado · evaluación de riesgos",
    "activity_item_completed_risk_assessment": "Elemento completado · evaluación de riesgos",
    "activity_schedule_recalculated_risk_assessment": "Programación recalculada · evaluación de riesgos",
    "activity_scheduled_run_created_risk_assessment": "Ejecución programada creada",
    "activity_incident_created_safety_document": "Incidente creado",
    "activity_incident_updated_safety_document": "Incidente actualizado",
    "activity_incident_closed_safety_document": "Incidente cerrado",
    "activity_certification_created_safety_document": "Certificación creada",
    "activity_certification_updated_safety_document": "Certificación actualizada",
    "activity_certification_archived_safety_document": "Certificación archivada",
    "activity_person_added_safety_document": "Persona añadida · documento de seguridad",
    "activity_person_updated_safety_document": "Persona actualizada · documento de seguridad",
    "activity_person_removed_safety_document": "Persona eliminada · documento de seguridad",
    "activity_witness_added_safety_document": "Testigo añadido · documento de seguridad",
    "activity_witness_updated_safety_document": "Testigo actualizado · documento de seguridad",
    "activity_witness_removed_safety_document": "Testigo eliminado · documento de seguridad",
    "activity_action_added_safety_document": "Acción añadida · documento de seguridad",
    "activity_action_updated_safety_document": "Acción actualizada · documento de seguridad",
    "activity_action_cancelled_safety_document": "Acción cancelada · documento de seguridad",
    "activity_attachment_added_safety_document": "Archivo adjunto añadido · documento de seguridad",
    "activity_attachment_uploaded_safety_document": "Archivo adjunto subido · documento de seguridad",
    "activity_attachment_removed_safety_document": "Archivo adjunto eliminado · documento de seguridad",
    "activity_created_safety_document": "Creado · documento de seguridad",
    "activity_updated_safety_document": "Actualizado · documento de seguridad",
    "activity_archived_safety_document": "Archivado · documento de seguridad",
    "activity_cancelled_safety_document": "Cancelado · documento de seguridad",
    "activity_completed_safety_document": "Completado · documento de seguridad",
    "activity_item_added_safety_document": "Elemento añadido · documento de seguridad",
    "activity_item_updated_safety_document": "Elemento actualizado · documento de seguridad",
    "activity_item_removed_safety_document": "Elemento eliminado · documento de seguridad",
    "activity_item_completed_safety_document": "Elemento completado · documento de seguridad",
    "activity_schedule_recalculated_safety_document": "Programación recalculada · documento de seguridad",
    "activity_scheduled_run_created_safety_document": "Ejecución programada creada",
    "activity_incident_closed": "Incidente cerrado",
    "activity_incident_created": "Incidente creado",
    "activity_certification_updated": "Certificación actualizada",
    "activity_checklist_completed": "Lista completada",
    "activity_checklist_run_created": "Ejecución de lista creada",
    "activity_risk_assessment_updated": "Evaluación de riesgos actualizada",
    "activity_document_archived": "Documento archivado",
    "activity_document_uploaded": "Documento subido"
  },
  "reminders": {
    "recipient": "equipo",
    "subject": "Lista para mañana: {name}",
    "hello": "Hola {name},",
    "checklist": "Lista: {name}",
    "due": "Vencimiento: {date}",
    "area": "Área/departamento: {area}",
    "category": "Categoría: {category}",
    "instructions": "Esta lista vence pronto. Complétala en el portal de Privana y consulta el registro de la lista para ver todos los detalles.",
    "openLink": "Abrir lista en Privana: {url}",
    "open": "Abrir lista en Privana",
    "logo": "Logotipo del club",
    "dueSentence": "{name} vence el {date}.",
    "title": "Lista para mañana",
    "body": "{name} vence el {date}. Abre Privana para completarla."
  }
};
